<template>
  <abstract-autocomplete
    v-model="localValue"
    :chips="chips"
    :clearable="clearable"
    :counter="counter"
    :deletable-chips="deletableChips"
    :dense="dense"
    :disabled="disabled"
    :id-predicate-path="idPredicatePath"
    :item-value="itemValue"
    :label="label"
    :list-api="listApi"
    :multiple="multiple"
    :outlined="outlined"
    :placeholder="placeholder"
    :preload-all-options="preloadAllOptions"
    :query-param="queryParam"
    :return-object="returnObject"
    :rounded="rounded"
    :rules="rules"
    :search-debounce-time="searchDebounceTime"
    :selected-item-to-text="selectedItemToText"
    :show-validation="showValidation"
    :single-line="singleLine"
    :small-chips="smallChips"
    :vid="vid"
    @change="$emit('change', $event)"
    @inputObject="$emit('inputObject', $event)"
  >
    <template v-slot:prepend-item>
      <slot name="prepend-item">
        <v-col>Id</v-col>
        <v-col>Identyfikator lokalizacji</v-col>
        <v-col>Nazwa klienta</v-col>
      </slot>
    </template>
    <template v-slot:item="{ data }">
      <slot :data="data" name="item">
        <v-col>{{ data.item.id }}</v-col>
        <v-col>{{ data.item.facilityNumber }}</v-col>
        <v-col>{{ data.item.clientName }}</v-col>
      </slot>
    </template>
  </abstract-autocomplete>
</template>

<script>
import { FacilityApi } from '@/context/facility/api/FacilityApi';
import AbstractAutocomplete
  from '@/general/component/form/autocomplete/abstract/AbstractAutocomplete';
import LocalValueInput from '@/general/component/form/autocomplete/abstract/LocalValueInput';
import AutocompleteProps from '@/general/component/form/autocomplete/abstract/AutocompleteProps';

export default {
  components: { AbstractAutocomplete },
  mixins: [LocalValueInput, AutocompleteProps],
  props: {
    value: {
      type: [Number, Object, Array],
      default: null
    },
    queryParam: {
      type: String,
      default: ""
    },
    idPredicatePath: {
      type: String,
      default: "id"
    },
    itemValue: {
      type: String,
      default: "id"
    },
    preloadAllOptions: {
      type: Boolean,
      default: false
    },
    vid: {
      type: String,
      default: "location"
    },
    label: {
      type: String,
      default: "Obiekt"
    },
    placeholder: {
      type: String,
      default: "Wybierz obiekt"
    },
    selectedItemToText: {
      type: Function,
      default: item => item.facilityNumber
    },
    listApi: {
      type: Function,
      default: FacilityApi.findAutocomplete
    }
  }
};
</script>

<style scoped></style>
